import "react-multi-carousel/lib/styles.css";
import useScrollReset from "@hooks/ScrollHook";
import { Link } from "react-router-dom";
import { useApi } from "@hooks/ApiHook";
import useModal from "@hooks/ModalHook";
import { resolveImageUrl } from "@helpers/image.helper";

function HomePage() {
  const { openModal } = useModal();
  useScrollReset();
  const { data: links } = useApi((api) => api.link.random());

  // Pilih data untuk kartu-kartu (fallback aman kalau API kosong)
  const featured = links?.[0] ?? {
    name: "BabiesOwl",
    subtitle: "Launchpad",
    url: "/launchpad",
    image:
      "https://ipfs.miata-ipfs.com/ipfs/QmYKNqaAh4TCbX42gGLy6DQsaHNVWzN85fKMcXTJ2yXBBh/1.png",
  };

  const rightTop = links?.[1] ?? {
    name: "Cookie Miners",
    subtitle: "Collection",
    url: "/collections",
    image: "https://i.imgur.com/2a3a9hV.jpeg", // ganti ke asetmu sendiri kalau ada
  };

  const rightBottom = links?.[2] ?? {
    name: "Baby Bulls Club",
    subtitle: "Launchpad",
    url: "/launchpad",
    image: "https://i.imgur.com/1yK7s4G.jpeg", // ganti ke asetmu sendiri kalau ada
  };

  return (
    <>
      <main className="pt-[5.5rem] lg:pt-24">
        {/* ===================== HERO BARU ===================== */}
        <section className="relative px-6 pb-3">
          <div className="mx-auto max-w-7xl">
            {/* Wrapper 12 kolom untuk layout desktop */}
            <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:items-start">
              {/* Kiri: Headline + Subcopy + CTA */}
              <div className="order-1 lg:order-none lg:col-span-6">
                <h1 className="mt-10 text-center font-display text-[2.4rem] leading-[1.1] text-white sm:text-5xl md:text-6xl lg:text-left lg:text-7xl">
                  The Permissionless
                  <br className="hidden sm:block" /> Marketplace
                </h1>

                <p className="mx-auto mt-4 max-w-xl text-center text-base leading-relaxed text-jacarta-300 lg:mx-0 lg:text-left">
                  Launch – create – mint – trade NFTs on Terra Classic
                  Blockchain
                </p>

                <div className="mt-6 flex flex-wrap justify-center gap-1 md:gap-4 lg:justify-start">
                  <Link
                    to="/launchpad"
                    className="rounded-md bg-accent text-xs px-1 py-1 md:text-base md:px-5 md:py-3 font-semibold text-white shadow-accent-volume transition-colors hover:bg-accent-dark"
                  >
                    View Launchpad
                  </Link>
                  <Link
                    to="/collections"
                    className="rounded-md bg-[#26B5CE] text-xs px-1 py-1 md:text-base md:px-5 md:py-3 font-semibold text-white transition-colors hover:brightness-110"
                  >
                    View Collection
                  </Link>
                </div>
              </div>

              {/* Kanan (desktop) / Bagian kartu (mobile+desktop) */}
              <div className="order-2 lg:order-none lg:col-span-6">
                {/* Grid kartu: SELALU 3 kolom (mobile juga), supaya mirip screenshot */}
                <div className="grid grid-cols-3 gap-6">
                  {/* Kartu besar: span 2 kolom */}
                  <div className="col-span-2">
                    <article className="relative overflow-hidden">
                      <figure className="relative">
                        <Link to={featured.url} className="group block">
                          <img
                            src={resolveImageUrl(
                                  featured.image ||
                                  "/src/img/logo/transparant_logo.png"
                            )}
                            alt={featured.name}
                            className="aspect-square w-full rounded-3xl object-cover transition-transform duration-[1600ms] will-change-transform group-hover:scale-105"
                          />
                        </Link>
                      </figure>
                      <div className="pointer-events-none mt-3 w-full px-1">
                        <h2 className="font-display text-lg text-white sm:text-xl">
                          {featured.name}
                        </h2>
                        {featured.subtitle && (
                          <span className="text-2xs text-white/90">
                            {featured.subtitle}
                          </span>
                        )}
                      </div>
                    </article>
                  </div>

                  {/* Kolom kanan: 2 kartu kecil ditumpuk */}
                  <div className="col-span-1 flex flex-col gap-6">
                    {/* Atas kecil */}
                    <article className="relative overflow-hidden">
                      <figure className="relative">
                        <Link
                          to={rightTop.url}
                          className="group block after:absolute after:inset-0 after:block after:bg-jacarta-900/20"
                        >
                          <img
                            src={resolveImageUrl(
                                  rightTop.image ||
                                  "/src/img/logo/transparant_logo.png"
                            )}
                            alt={rightTop.name}
                            className="aspect-square w-full rounded-3xl object-cover transition-transform duration-[1600ms] will-change-transform group-hover:scale-105"
                          />
                        </Link>
                      </figure>
                      <div className="pointer-events-none mt-2 w-full px-1">
                        <h3 className="font-display text-sm text-white">
                          {rightTop.name}
                        </h3>
                        {rightTop.subtitle && (
                          <span className="text-[10px] text-white/90">
                            {rightTop.subtitle}
                          </span>
                        )}
                      </div>
                    </article>

                    {/* Bawah kecil */}
                    <article className="relative overflow-hidden">
                      <figure className="relative">
                        <Link
                          to={rightBottom.url}
                          className="group block after:absolute after:inset-0 after:block after:bg-jacarta-900/20"
                        >
                          <img
                            src={resolveImageUrl(
                                  rightBottom.image ||
                                  "/src/img/logo/transparant_logo.png"
                            )}
                            alt={rightBottom.name}
                            className="aspect-square w-full rounded-3xl object-cover transition-transform duration-[1600ms] will-change-transform group-hover:scale-105"
                          />
                        </Link>
                      </figure>
                      <div className="pointer-events-none mt-2 w-full px-1">
                        <h3 className="font-display text-sm text-white">
                          {rightBottom.name}
                        </h3>
                        {rightBottom.subtitle && (
                          <span className="text-[10px] text-white/90">
                            {rightBottom.subtitle}
                          </span>
                        )}
                      </div>
                    </article>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default HomePage;
